<app-performance>
    <app-data-grid-comp
        [gridId]="gridId"
        [tableId]="db_tables.PerformanceReviewPlans"
        [columns]="columns"
        [filterCategories]="filterCategories"
        hideActionButtons="true"
        [gridDataResult]="gridDataResult"
        [isLoading]="isLoading"
        [pageSize]="pageSize"
        [skip]="skip"
        category="GlobalReviewPlans"
        [rowSelectionSettings]="{
            canSelectRows: false
        }"
        clickableRows="true"
        [isLoading]="isLoading"
        searchable="true"
        [sortable]="{
            mode: 'multiple'
        }"
        [sortableColumns]="sortableColumns"
        (emitGridStateChangeEvent)="gridStateChange($event)"
        (emitOpenDialogEvent)="getReviewPlan($event)"
    ></app-data-grid-comp>
</app-performance>
